import { type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Wordmark } from './Wordmark';
import { Rodape } from './Rodape';
import { IconeSeta } from './icones';

/**
 * Shell do portal do cliente (DESIGN-FOUNDATION §3.1): uma coluna de 480px
 * centrada sobre `--fundo`, gutter de 20px, mobile-first. Sem sidebar, sem
 * layout de duas colunas nem em desktop. O painel usa outro shell.
 */
export function PortalShell({
  children,
  voltarPara,
  voltarRotulo = 'Voltar',
}: {
  children: ReactNode;
  /** rota do link "voltar"; ausente = mostra o wordmark discreto (Home) */
  voltarPara?: string;
  voltarRotulo?: string;
}): ReactNode {
  return (
    <div className="min-h-screen bg-fundo px-5 py-6">
      <div className="mx-auto w-full max-w-[480px]">
        <header className="mb-8">
          {voltarPara ? (
            <Link
              to={voltarPara}
              className="tipo-corpo -ml-1 inline-flex min-h-[48px] items-center gap-1 text-tinta-2"
            >
              <IconeSeta className="rotate-180" />
              {voltarRotulo}
            </Link>
          ) : (
            <Link to="/" aria-label="Início">
              <Wordmark largura={108} />
            </Link>
          )}
        </header>
        <main>{children}</main>
        <Rodape />
      </div>
    </div>
  );
}
